import { Button, FlexBox, Logo, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ShareObjectType } from '@fable/types'
import { useShareObject } from './useShareObject'
import { getCmsAsset } from '@fable/utils'

interface Props {
  id: string
  type: ShareObjectType
}

export const SharePageFooter = ({ id, type }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const { onClickCta } = useShareObject()

  return (
    <FlexBox
      className={css`
        padding: 32px 0 0;
        background-color: ${colors.uiPearlExtraLight};
        position: relative;
        overflow: hidden;
        ${mediaQueries.tablet} {
          height: 560px;
        }
      `}
      alignItems="center"
      flexDirection="column"
    >
      <FlexBox
        className={css`
          position: relative;
          z-index: 1;
        `}
        alignItems="center"
        flexDirection="column"
      >
        <FlexBox
          className={css`
            width: 40px;
            height: 40px;
            background-color: ${colors.fableGreenDarker};
            border-radius: 12px;
          `}
          justifyContent="center"
          alignItems="center"
        >
          <Logo
            className={css`
              width: 28px;
              svg {
                width: 100%;
              }
            `}
            isIcon
          />
        </FlexBox>
        <Text
          className={css`
            margin: 16px 0;
            font-size: 40px;
            ${mediaQueries.mobileL} {
              margin-top: 30px;
              font-size: 50px;
            }
          `}
          tag="h2"
          type="note"
          sizing="M"
          align="center"
          color={colors.uiGraphite}
        >
          Welcome home
        </Text>
        <Text
          className={css`
            max-width: 250px;
            font-size: 36px;
            line-height: 36px;
            ${mediaQueries.mobileL} {
              max-width: 350px;
              font-size: 48px;
              line-height: 48px;
            }
          `}
          type="header"
          align="center"
          sizing="M"
          color={colors.uiGraphite}
        >
          Bookworms and binge-watchers
        </Text>
        <Button
          className={css`
            margin-top: 24px;
            width: 100%;
            max-width: 175px;
            height: 52px;
          `}
          onClick={() =>
            onClickCta({ id, type, cta: 'footer', skipModalOnMobile: true })
          }
        >
          Download the app
        </Button>
      </FlexBox>
      <img
        className={css`
          margin-top: 25px;
          margin-bottom: -150px;
          display: block;
          width: 90%;
          max-width: 500px;
          ${mediaQueries.tablet} {
            display: none;
          }
        `}
        src={getCmsAsset(
          '1qCU9t62RxRnesY0XdIbvn/384370bae8aed5e28365281d65fe5247/fable-app-iphone-13-mockup.webp'
        )}
        alt="fable app iphone mockup"
      />
      <div
        className={css`
          display: none;
          ${mediaQueries.tablet} {
            display: block;
            margin-top: 0;
            margin-bottom: 0;
            width: 100%;
            max-width: 1000px;
            height: 500px;
            position: absolute;
            bottom: 5%;
            left: 50%;
            transform: translateX(-50%);
          }
        `}
      >
        <img
          className={css`
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            position: absolute;
            left: -30%;
            top: 0;
          `}
          src={getCmsAsset(
            '6hs0BZlYpndi1hUxxlFick/a00ca8d4e1e62585dba090df8ef2a989/fable-app-iphone-13-mockup-left.webp'
          )}
          alt="fable app iphone mockup left"
        />
        <img
          className={css`
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            position: absolute;
            right: -30%;
            top: 0;
          `}
          src={getCmsAsset(
            '6GqtS4nKLM88pm2TBwDoch/66d90eb5c3244345b08e91bf390630d4/fable-app-iphone-13-mockup-right.webp'
          )}
          alt="fable app iphone mockup right"
        />
      </div>
    </FlexBox>
  )
}
